import { z } from 'zod'
import { guidSchema } from '../../contracts/_common'

export const JobCostNoteSchema = z.object({
  noteGuid: guidSchema,
  noteLinkGuid: guidSchema,
  companyGuid: guidSchema,
  jobGuid: guidSchema,
  noteType: z.literal('job_cost'),
  value: z.string().min(1).max(500),
  createdAt: z.string(),
  createdByUserGuid: guidSchema,
  createdByUser: z
    .object({
      firstName: z.string().nullable(),
      lastName: z.string().nullable(),
    })
    .nullable(),
  addressedAt: z.string().nullable(),
  addressedByUserGuid: guidSchema.nullable(),
  addressedByUser: z
    .object({
      firstName: z.string().nullable(),
      lastName: z.string().nullable(),
    })
    .nullable(),
})

export type JobCostNote = z.infer<typeof JobCostNoteSchema>

export const CreateJobCostNoteInputSchema = z.object({
  jobGuid: guidSchema,
  value: z.string().min(1).max(500),
})

export type CreateJobCostNoteInput = z.infer<typeof CreateJobCostNoteInputSchema>

export const DismissJobCostNoteInputSchema = z.object({
  noteLinkGuid: guidSchema,
})

export type DismissJobCostNoteInput = z.infer<typeof DismissJobCostNoteInputSchema>
